import { useCallback, useEffect, useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { subscriptionService } from '../services/subscriptionService';

export const useCreditBalance = () => {
  const { isAuthenticated } = useAuth();
  const [creditBalance, setCreditBalance] = useState<number | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  const refresh = useCallback(async () => {
    if (!isAuthenticated) return;
    setIsLoading(true);
    try {
      const balance = await subscriptionService.getCreditBalance();
      setCreditBalance(balance);
    } catch (error) {
      console.error('Failed to load credit balance:', error);
    } finally {
      setIsLoading(false);
    }
  }, [isAuthenticated]);

  useEffect(() => {
    if (!isAuthenticated) {
      setCreditBalance(null);
      return;
    }

    refresh();
  }, [isAuthenticated, refresh]);

  useEffect(() => {
    if (!isAuthenticated) return;

    const handleUpdate = () => {
      refresh();
    };

    window.addEventListener('credits-updated', handleUpdate);
    return () => {
      window.removeEventListener('credits-updated', handleUpdate);
    };
  }, [isAuthenticated, refresh]);

  return {
    creditBalance,
    isLoading,
    refresh,
  };
};
